import { Component } from '@angular/core';
import { enableProdMode } from '@angular/core';

enableProdMode();

@Component({
    selector: 'app-signature',
    templateUrl: './signature.component.html'
})

export class SignatureComponent {}